import { useViewSetting } from '@upright/ui/common/generic/hooks';

/**
 * Whether to show Leena-2 80% intervals: team users with the "Show Leena-2
 * uncertainty" view setting on (off by default). `useViewSetting` re-checks
 * team status, so a stale setting on a customer account is a no-op.
 */
export function useShowLeena2Uncertainty(): boolean {
  return useViewSetting('leena2.showUncertainty');
}
